import axios from "axios";
import API_BASE_URL from "../constant/Api_base_url";
import { getXsrf, setXsrf } from "./xsrf";

// P1: central axios instance – new code should use this instead of raw axios.
// TODO: migrate existing axios callers to `api` incrementally.
const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  // In-memory CSRF: document.cookie can never see API-domain cookies cross-origin.
  // httpOnly cookie-only: never inject Bearer from localStorage.
  // GET/HEAD/OPTIONS are CSRF-exempt server-side: keep them CORS-simple
  // (no custom header = no preflight).
  const method = (config.method || "get").toLowerCase();
  if (method === "get" || method === "head" || method === "options") return config;
  const t = getXsrf();
  if (t) {
    config.headers = config.headers || {};
    config.headers["x-xsrf-token"] = t;
  }
  return config;
});

function isAuthProbe(url) {
  if (!url) return false;
  return url.includes("/auth/check") || /\/auth\/.*Login/.test(url);
}

api.interceptors.response.use(
  (r) => {
    // Auto-harvest the xsrf synchronizer token (login, /auth/me carry it)
    // so mutating calls work without explicit setXsrf wiring.
    const t = r && r.data && r.data.xsrf;
    if (typeof t === "string" && t.length === 64) {
      setXsrf(t);
    }
    return r;
  },
  (e) => {
    if ((e?.response?.status === 401 || e?.response?.status === 403) && !isAuthProbe(e?.config?.url)) {
      window.dispatchEvent(new Event("auth:logout"));
    }
    return Promise.reject(e);
  }
);

export default api;

// --- Global CSRF for the default axios instance -------------------------
// Most of the app (bet placement, ledger, auth, etc.) still calls the
// default `axios` directly. Axios instance interceptors do NOT apply to the
// default instance, so without this every mutating call 403s with
// "CSRF validation failed". Mirror the instance behaviour globally: attach
// `x-xsrf-token` to non-simple requests and harvest the token any response
// hands back.
function attachGlobalXsrf(config) {
  const method = (config.method || "get").toLowerCase();
  if (method === "get" || method === "head" || method === "options") return config;
  const t = getXsrf();
  if (t) {
    config.headers = config.headers || {};
    config.headers["x-xsrf-token"] = t;
  }
  return config;
}

function harvestGlobalXsrf(r) {
  const t = r && r.data && r.data.xsrf;
  if (typeof t === "string" && t.length === 64) {
    setXsrf(t);
  }
  return r;
}

axios.interceptors.request.use(attachGlobalXsrf);
axios.interceptors.response.use(harvestGlobalXsrf);

